document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector(".nav-toggle");
  const navMenu = document.querySelector(".nav-menu-wrapper");

  if (toggle && navMenu) {
    toggle.addEventListener("click", () => {
      //set the top position of the menu to be the height of the main nav, so it appears just below it when opened.
      const mainNavHeight = document
        .querySelector(".main-nav")
        .getBoundingClientRect().height;
      navMenu.style.top = `${mainNavHeight}px`;

      //toggle open state and aria attribute for accessibility
      const open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      navMenu.classList.toggle("is-open", !open);
    });
  }

  // Mobile submenu toggle
  const menuItems = document.querySelectorAll(".menu-item-has-children > a");

  menuItems.forEach((link) => {
    link.addEventListener("click", (e) => {
      // Only handle on mobile (when nav-toggle is visible)
      if (toggle && window.getComputedStyle(toggle).display !== "none") {
        e.preventDefault();

        const parentLi = link.parentElement;
        const subMenu = Array.from(parentLi.children).find(
          (child) => child.classList && child.classList.contains("sub-menu")
        );

        if (subMenu) {
          const isOpen = parentLi.classList.contains("submenu-open");
          const parentUl = parentLi.parentElement;

          // Close other open sibling submenu parents only, not open ancestors.
          Array.from(parentUl.children)
            .filter(
              (child) =>
                child !== parentLi &&
                child.classList &&
                child.classList.contains("menu-item-has-children") &&
                child.classList.contains("submenu-open")
            )
            .forEach((openItem) => {
              openItem.classList.remove("submenu-open");
              const openSubMenu = openItem.querySelector(
                ".sub-menu.is-open"
              );
              if (openSubMenu) {
                openSubMenu.classList.remove("is-open");
              }
            });

          parentLi.classList.toggle("submenu-open", !isOpen);
          subMenu.classList.toggle("is-open", !isOpen);
        }
      }
    });
  });

  // Disable links for mega menu parent items (desktop and mobile)
  const megaMenuParents = document.querySelectorAll("li.mega-menu-parent > a");

  megaMenuParents.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });

  // Sticky nav on scroll (desktop only)
  const mainNav = document.querySelector(".main-nav");
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;

    // Scrolling down - add scrolled class after 100px
    if (currentScroll > lastScroll && currentScroll > 100) {
      mainNav.classList.add("scrolled");
    }
    // Only remove scrolled class when near the top (< 50px)
    else if (currentScroll < 50) {
      mainNav.classList.remove("scrolled");
    }

    lastScroll = currentScroll;
  });
});
